import { FC, useState } from 'react';
import { Box, Center, Image, VStack } from '@chakra-ui/react';

import Easy from 'assets/brand/easy.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import { BANK_ACCOUNT_ILLUSTRATIONS } from 'components/BankAccountIcon/constants';
import Carousel from 'components/Carousel';
import * as Layout from 'layouts/ContentLayout';

import locales from './locales';

interface BankAccountCarouselProps {
  backButtonPath?: string;
  startFromTheEnd?: boolean;
  onCarouselEnd: () => void;
}

const items = [
  {
    illustration: BANK_ACCOUNT_ILLUSTRATIONS['cash-register'],
    ...locales.slides[0],
  },
  {
    illustration: Easy,
    ...locales.slides[1],
  },
  {
    illustration: BANK_ACCOUNT_ILLUSTRATIONS['safe'],
    ...locales.slides[2],
  },
];

const BankAccountCarousel: FC<BankAccountCarouselProps> = ({
  backButtonPath,
  onCarouselEnd,
  startFromTheEnd,
}) => {
  const lastItemIndex = items.length - 1;
  const [index, setIndex] = useState(startFromTheEnd ? lastItemIndex : 0);

  const handleNextClick = () => setIndex((i) => i + 1);

  const isLastSlide = index === lastItemIndex;

  return (
    <Layout.Root>
      <Layout.Body>
        <Box marginBottom="space-16">
          <BackButton {...(backButtonPath && { to: backButtonPath })} />
        </Box>
        <Layout.BodyScrollableSection>
          <Box borderColor="grey.300" borderRadius="radius-8" borderWidth="1px">
            <Box padding="space-32">
              <Carousel
                marginBottom="space-0"
                onChange={setIndex}
                value={index}
              >
                {items.map((item) => (
                  <VStack
                    height="300px"
                    key={index}
                    marginBottom="space-32"
                    spacing="space-16"
                  >
                    <Image
                      alt={`${item.illustration}`}
                      boxSize="144px"
                      fit="cover"
                      role="presentation"
                      src={item.illustration}
                    />
                    <Heading fontSize="font-26" textAlign="center">
                      {item.title}
                    </Heading>
                    <Text textAlign="center">{item.text}</Text>
                  </VStack>
                ))}
              </Carousel>
            </Box>
            <Center
              borderColor="grey.300"
              borderTopWidth="1px"
              padding="space-24"
            >
              <Button
                isExpanded
                onClick={isLastSlide ? onCarouselEnd : handleNextClick}
              >
                {isLastSlide ? locales.begin : locales.next}
              </Button>
            </Center>
          </Box>
        </Layout.BodyScrollableSection>
      </Layout.Body>
    </Layout.Root>
  );
};

export default BankAccountCarousel;
